export const LOCAL_STORAGE_AUTH = "auth";
export const LOCAL_STORAGE_LOGIN = "login";

export const LOCAL_STORAGE_OBJECT_FILTER = "filter";

export const LOCAL_STORAGE_LANGUAGE = "lang";
